export default __webpack_public_path__ + "static/media/logo.ed1510f3.png";